<template>
  <div class="ai-statistics-tab">
    
  </div>
</template>

<script setup></script>
